import { getSecurityKey } from './security'
import type { GroupedPosition } from '../reducer/positions.reducer'
import type { Position } from '../proto/generated/position'
import type { Holding } from '../reducer/holdings.reducer'

export const getPositionSecurityKeys = (position: GroupedPosition): string[] => {
    const keys = new Set<string>()
    const add = (p: { security: { exchange: number; code: string } }) => {
        keys.add(getSecurityKey(p.security.exchange, p.security.code))
    }
    add(position)
    position.children?.forEach(add)
    return [...keys]
}

export const getPositionsSecurityKeys = (positions: Position[]): string[] => {
    const keys = new Set<string>()
    positions.forEach((p) => keys.add(getSecurityKey(p.security.exchange, p.security.code)))
    return [...keys]
}

export const getHoldingsSecurityKeys = (holdings: Holding[]): string[] => {
    const keys = new Set<string>()
    holdings.forEach((holding) => {
        if (holding.security) {
            keys.add(getSecurityKey(holding.security.exchange, holding.security.code))
        }
    })
    return [...keys]
}

export const parseLtpsSignature = (signature: string): number[] => {
    if (!signature) return []
    return signature.split('\0').map((v) => Number(v))
}

export const buildLtpsByKey = (keys: readonly string[], ltpsSignature: string): Map<string, number> => {
    const map = new Map<string, number>()
    const ltps = parseLtpsSignature(ltpsSignature)
    keys.forEach((key, i) => {
        map.set(key, ltps[i] ?? 0)
    })
    return map
}
